import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  transition: all 0.25s ease-in-out;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 15%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ', ';\n  left: 0;\n  position: relative;\n  top: 0;\n  width: ', ';\n\n  ', '\n'], ['\n  transition: all 0.25s ease-in-out;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-radius: 15%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ', ';\n  left: 0;\n  position: relative;\n  top: 0;\n  width: ', ';\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      background-color: ', ';\n      border-color: ', ';\n\n      svg {\n        width: calc(', ' * 0.7);\n        height: calc(', ' * 0.7);\n      }\n    '], ['\n      background-color: ', ';\n      border-color: ', ';\n\n      svg {\n        width: calc(', ' * 0.7);\n        height: calc(', ' * 0.7);\n      }\n    ']);

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { IconCheck } from './Icons';

var StyledCheckMark = styled.span(_templateObject, function (props) {
  return props.theme.dormifyWhite;
}, function (props) {
  return props.theme.dormifyLightGrey;
}, function (props) {
  return props.spanWidth;
}, function (props) {
  return props.spanWidth;
}, function (_ref) {
  var checked = _ref.checked,
      theme = _ref.theme;
  return checked && css(_templateObject2, theme.dormifyPink, theme.dormifyPink, function (props) {
    return props.spanWidth;
  }, function (props) {
    return props.spanWidth;
  });
});

var _ref2 = React.createElement(IconCheck, { stroke: '#FFFFFF' });

var Checkbox = function Checkbox(props) {
  return React.createElement(
    StyledCheckMark,
    {
      checked: props.checked,
      spanWidth: props.width,
      style: props.styles
    },
    props.checked && _ref2
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  width: PropTypes.string,
  styles: PropTypes.object
};

export default Checkbox;